export interface UserContextRoleScopeProfileDTO {
    contextProfileCd?: string;
    contextProfileName?: string;
}
